/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EducationConstraintSchema } from './educationConstraintSchema';
import type { ExperienceConstraintSchema } from './experienceConstraintSchema';
import type { FilterValueSchema } from './filterValueSchema';
import type { HideReviewedFilterSchema } from './hideReviewedFilterSchema';
import type { HideViewedFilterSchema } from './hideViewedFilterSchema';
import type { LocationFilterSchema } from './locationFilterSchema';
import type { NetworkFilterSchema } from './networkFilterSchema';
import type { PoolMembershipFilterSchema } from './poolMembershipFilterSchema';
import type { SearchFiltersSchemaCertificationStatus } from './searchFiltersSchemaCertificationStatus';
import type { SearchFiltersSchemaCompanyTagFilterType } from './searchFiltersSchemaCompanyTagFilterType';
import type { SearchFiltersSchemaFundingFilterType } from './searchFiltersSchemaFundingFilterType';
import type { SearchFiltersSchemaFundingScope } from './searchFiltersSchemaFundingScope';
import type { SearchFiltersSchemaIndustryFilterType } from './searchFiltersSchemaIndustryFilterType';
import type { SearchFiltersSchemaInvestorFilterType } from './searchFiltersSchemaInvestorFilterType';
import type { SearchFiltersSchemaJtFilterType } from './searchFiltersSchemaJtFilterType';
import type { SearchFiltersSchemaMinDegree } from './searchFiltersSchemaMinDegree';
import type { SimpleFilterEntitySchema } from './simpleFilterEntitySchema';
import type { SkillFilterSchema } from './skillFilterSchema';
import type { TenureFilterSchema } from './tenureFilterSchema';
import type { VariantFilterValueSchema } from './variantFilterValueSchema';
import type { VariantSimpleFilterEntitySchema } from './variantSimpleFilterEntitySchema';

export interface SearchFiltersSchema {
  job_titles?: VariantFilterValueSchema[] | null;
  past_job_titles?: VariantFilterValueSchema[] | null;
  jt_filter_type?: SearchFiltersSchemaJtFilterType;
  job_title_levels?: FilterValueSchema[] | null;
  job_title_roles?: FilterValueSchema[] | null;
  locations?: LocationFilterSchema[] | null;
  distance?: string;
  past_locations?: LocationFilterSchema[] | null;
  company_locations?: LocationFilterSchema[] | null;
  university_locations?: LocationFilterSchema[] | null;
  companies?: VariantFilterValueSchema[] | null;
  company_sizes?: ('1-10' | '11-50' | '51-200' | '201-500' | '501-1000' | '1001-5000' | '5001-10000' | '10001+')[] | null;
  company_tags?: VariantSimpleFilterEntitySchema[] | null;
  company_tag_filter_type?: SearchFiltersSchemaCompanyTagFilterType;
  company_founded_after?: number | null;
  company_funding_stages?: FilterValueSchema[] | null;
  funding_filter_type?: SearchFiltersSchemaFundingFilterType;
  investors?: FilterValueSchema[] | null;
  investor_filter_type?: SearchFiltersSchemaInvestorFilterType;
  min_funding?: number | null;
  max_funding?: number | null;
  funding_scope?: SearchFiltersSchemaFundingScope;
  revenue_ranges?: FilterValueSchema[] | null;
  industries?: VariantFilterValueSchema[] | null;
  industry_filter_type?: SearchFiltersSchemaIndustryFilterType;
  skills?: SkillFilterSchema[] | null;
  keywords?: string[] | null;
  min_experience_years?: number | null;
  max_experience_years?: number | null;
  time_current_role?: TenureFilterSchema | null;
  time_current_company?: TenureFilterSchema | null;
  average_tenure_min_months?: number | null;
  universities?: VariantFilterValueSchema[] | null;
  min_degree?: SearchFiltersSchemaMinDegree;
  majors?: VariantSimpleFilterEntitySchema[] | null;
  grad_year_start?: number | null;
  grad_year_end?: number | null;
  experience_constraints?: ExperienceConstraintSchema[] | null;
  education_constraints?: EducationConstraintSchema[] | null;
  languages?: SimpleFilterEntitySchema[] | null;
  certification_names?: VariantSimpleFilterEntitySchema[] | null;
  certification_vendors?: VariantSimpleFilterEntitySchema[] | null;
  certification_status?: SearchFiltersSchemaCertificationStatus;
  occupational_series?: FilterValueSchema[] | null;
  gs_grade_min?: number | null;
  gs_grade_max?: number | null;
  gs_include_equivalents?: boolean;
  boolean_expression?: string | null;
  full_names?: FilterValueSchema[] | null;
  full_text_search?: string | null;
  highlight_types?: SimpleFilterEntitySchema[] | null;
  power_filters?: SimpleFilterEntitySchema[] | null;
  clearance_levels?: ('public_trust' | 'confidential' | 'secret' | 'top_secret' | 'ts_sci' | 'doe_l' | 'doe_q')[] | null;
  clearance_strict?: boolean | null;
  clearance_polygraphs?: ('ci' | 'full_scope' | 'lifestyle')[] | null;
  likely_to_switch?: string[] | null;
  exclude_org_companies?: boolean;
  exclude_org_profiles?: boolean;
  exclude_dnc_companies?: boolean;
  exclude_dnc_countries?: boolean;
  hide_viewed?: HideViewedFilterSchema | null;
  hide_reviewed?: HideReviewedFilterSchema | null;
  pool_membership?: PoolMembershipFilterSchema | null;
  network?: NetworkFilterSchema | null;
  profile_ids?: string[] | null;
}
